import classNames from 'classnames';
import * as React from 'react';
import { useEffect, useRef, useState } from 'react';
import { Loading } from 'tdesign-react';

import { Upload } from '@/components/icon';
import { LIMIT_AUDIO } from '@/const/form';
import { EAsyncStatus } from '@/interface/media';
import { INewUploadIProps } from '@/interface/upload';

import { emitRichMediaFile } from '../../change-data';
import RefUpload, { UploadStatus } from '../ref';
import styles from './index.module.less';

interface UploadFileProps extends INewUploadIProps {
  uploadAreaOnChange: (params: { url: string; name: string }) => any;

  limit?: {
    fileType?: string[];
    size?: number;
    showSizeMsg?: string;
  };
  disabled?: boolean;
  text?: string;
}

export const mediaDefaultValue = {
  url: {
    url: '',
    localPath: '',
    name: '',
  },
  showType: 0,
  autoPlay: false,
  loopPlay: false,
};

/**
 * 上传内容组件
 * 视频，音频
 */
export const UploadContent: React.FC<UploadFileProps> = (props) => {
  const {
    limit = { ...LIMIT_AUDIO, fileType: LIMIT_AUDIO.uploadType },
    uploadAreaOnChange,
    asyncUploadOnChange,
    text = '上传文件',
    disabled,
    value,
  } = props;

  const tdUploadElementRef = useRef<{
    upload: () => void;
    status: () => UploadStatus;
  }>(null);

  const [asyncLoading, setAsyncLoading] = useState<boolean>(false);
  const loading = tdUploadElementRef?.current?.status() === UploadStatus.LOADING;

  const handleUploadOnchange = (params: { url: string; name: string }) => {
    const { url } = params;
    emitRichMediaFile(url);
    uploadAreaOnChange(params);
  };

  const handleClickUpload = () => {
    if (loading || disabled) {
      return;
    }
    tdUploadElementRef?.current?.upload?.();
  };

  useEffect(() => {
    if (asyncUploadOnChange) {
      if (value?.asyncStatus === EAsyncStatus.UPLOAD_LOADING) {
        setAsyncLoading(true);
      } else {
        setAsyncLoading(false);
      }
    }
  }, [value?.asyncStatus, asyncUploadOnChange]);


  return (
    <>
      <div
        onClick={handleClickUpload}
        className={classNames(styles.item, {
          ['nova-disabled-opacity']: disabled,
          ['nova-disabled']: disabled,
        })}
      >
        {loading || asyncLoading ? (
          <Loading size="small" text="上传中" />
        ) : (
          <div className={styles.textWrap}>
            <Upload style={{ width: 15, height: 15 }} />
            <span>{text}</span>
          </div>
        )}
      </div>
      <div className={styles.tdUpload}>
        <RefUpload
          uploadRef={tdUploadElementRef}
          onChange={handleUploadOnchange}
          limit={limit}
          asyncUploadOnChange={asyncUploadOnChange}
        />
      </div>
    </>
  );
};
